<script lang="ts">
	import { page } from '$app/state';
	import { discountCodesSlugs, mediaUrl } from '$lib';
	import { cmsPageLink, cmsPageLinkAsLi } from '$lib/components/snippets.svelte';
	import { m } from '$lib/paraglide/messages';

	import Brands from './homepage/Brands.svelte';
	import Newsletter from './newsletter/Newsletter.svelte';
	import SocialLinks from './SocialLinks.svelte';
	import StoresLinks from './StoresLinks.svelte';
	import Trustbox from './third-parties/trustpilot/Trustbox.svelte';

	const {
		store,
		brandsBlock,
	}: {
		store: Config;
		brandsBlock: BrandBlock[] | null;
	} = $props();
</script>

<footer class="mt-8 w-full justify-center bg-neutral-900 text-white">
	{#if brandsBlock && page.url.pathname !== '/'}
		<div class="bg-white">
			<div class="full-container mx-auto px-4 py-14">
				<Brands block={brandsBlock} />
			</div>
		</div>
	{/if}

	<div class="mt-2 mb-3 flex w-full flex-wrap justify-center border-b border-b-white py-4 text-xs">
		<div class="basis-2xs px-4 py-3 text-center">
			<span class="icon-[mdi--location] h-10 w-10 text-white"></span>
			<div>
				<h3 class="mb-3 text-sm text-nowrap uppercase">
					{m['reinsurances.after_sales_services']()}
				</h3>
				<div>
					{@render cmsPageLink('contact-us')}
				</div>
				<div>
					11 rue Bernard Maris
					<br />
					37270 Montlouis-sur-Loire
				</div>
				<div>France</div>
				<div>+33 1 86 47 62 58</div>
			</div>
		</div>
		<div class="basis-2xs px-4 py-3 text-center">
			<span class="icon-[mdi--credit-card-lock] h-10 w-10 text-white"></span>
			<div>
				<h3 class="mb-3 text-sm uppercase">
					{m['reinsurances.safe_payment']()}
				</h3>
				<div>{m['reinsurances.safe_payment_subtext']()}</div>
				<div class="mx-auto mt-2 flex w-fit gap-1">
					<img
						alt="paypal"
						src={mediaUrl(page.data.store.media_base_url, 'atos/logo/PAYPAL.gif')}
						width="22"
						class="h-[14px] w-[22px]"
					/>
					<img
						alt="cb"
						src={mediaUrl(page.data.store.media_base_url, 'atos/logo/CB.gif')}
						width="22"
						class="h-[14px] w-[22px]"
					/>
					<img
						alt="visa"
						src={mediaUrl(page.data.store.media_base_url, 'atos/logo/VISA.gif')}
						width="22"
						class="h-[14px] w-[22px]"
					/>
					<img
						alt="mastercard"
						src={mediaUrl(page.data.store.media_base_url, 'atos/logo/MASTERCARD.gif')}
						width="22"
						class="h-[14px] w-[22px]"
					/>
				</div>
			</div>
		</div>
		<div class="basis-2xs px-4 py-3 text-center">
			<div>
				<span class="text-[2rem] font-bold">4x</span>
				<h3 class="mb-3 text-sm uppercase">
					{m['reinsurances.multiple_time_payment']()}
				</h3>
				<div>
					<img
						class="inline-block"
						alt="paypal"
						src={mediaUrl(page.data.store.media_base_url, 'paypal/PP_logo_white_h_100x26.png')}
					/>
				</div>
			</div>
		</div>
		<div class="basis-2xs px-4 py-3 text-center">
			<span class="icon-[mdi--truck-fast] h-10 w-10 text-white"></span>
			<div>
				<h3 class="mb-3 text-sm uppercase">{m['reinsurances.return']()}</h3>
				<div>
					{m['reinsurances.return_subtext']()}
					<br />
					<a data-sveltekit-reload href="/rma" target="_blank">
						{m['reinsurances.return_link_text']()}
					</a>
				</div>
			</div>
		</div>
		<Trustbox
			trustpilot={store.third_parties?.trustpilot}
			base_url={store.base_url}
			locale={store.locale}
		/>
	</div>
	<div class="full-container mx-auto p-4 xl:flex xl:justify-evenly">
		<div class="flex flex-col justify-around gap-y-4 md:flex-row xl:gap-x-14">
			<div class="flex flex-col justify-around gap-y-4 lg:flex-row lg:gap-x-10">
				<div>
					<h3 class="mb-2 font-bold">{m['footer.services.services']()}</h3>
					<ul>
						<li><a href="/customer/order">{m['footer.services.my_account']()}</a></li>
						<li><a href="/sales/guest/form">{m['footer.services.follow_my_order']()}</a></li>
						<li>
							<a data-sveltekit-reload href="/rma" target="_blank"
								>{m['footer.services.return_my_order']()}</a
							>
						</li>
						<li>
							<a href="/{discountCodesSlugs[store.language]}" target="_self"
								>{m['footer.services.promo_code']()}</a
							>
						</li>
					</ul>
				</div>
				<div>
					<h3 class="mb-2 font-bold">{m.about()}</h3>
					<ul>
						{@render cmsPageLinkAsLi('about-us')}
						{@render cmsPageLinkAsLi('contact-us')}
						{@render cmsPageLinkAsLi('term-of-sales')}
						{@render cmsPageLinkAsLi('returns-refunds')}
						{@render cmsPageLinkAsLi('legal-disclaimer')}
						{@render cmsPageLinkAsLi('means-of-payment')}
						{@render cmsPageLinkAsLi('shipping-rates')}
						{@render cmsPageLinkAsLi('privacy-statement')}
						{@render cmsPageLinkAsLi('shop')}
					</ul>
				</div>

				{#if store.stores_links?.length}
					<StoresLinks storesLinks={store.stores_links} />
				{/if}
			</div>
		</div>

		<div class="mt-4 flex flex-col xl:mt-0 xl:gap-4">
			<Newsletter />

			{#if store.social_links}
				<SocialLinks socials={store.social_links} />
			{/if}
		</div>
	</div>
</footer>
